module.exports = __webpack_public_path__ + "img/congratulations-john.93b2c324.png";